import Api from '@teko/api';
import { accessTokenInterceptor } from '@teko/auth';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
class LocationService {
  constructor(locationApiUrl, defaultConfig, getCustomAccessToken, countryCode) {
    this.getProvinces = async () => {
      return this.locationApi.get(`/location/provinces${!!this.country ? `?country=${this.country}` : ""}`).then(({ data }) => {
        var _a;
        return Promise.resolve((_a = data.result) == null ? void 0 : _a.provinces);
      });
    };
    this.getDistrictsByProvinceCode = async (provinceCode) => {
      return this.locationApi.get(`/location/districts?provinceCode=${provinceCode}${!!this.country ? `&country=${this.country}` : ""}`).then(({ data }) => {
        var _a;
        return Promise.resolve((_a = data.result) == null ? void 0 : _a.districts);
      });
    };
    this.getWardsByDistrictCode = async (districtCode) => {
      return this.locationApi.get(`/location/wards?districtCode=${districtCode}${!!this.country ? `&country=${this.country}` : ""}`).then(({ data }) => {
        var _a;
        return Promise.resolve((_a = data.result) == null ? void 0 : _a.wards);
      });
    };
    this.getAddressSuggestions = async (params) => {
      return this.locationApi.get("/location/addresses/suggest", { params }).then((res) => {
        var _a, _b;
        return ((_b = (_a = res.data) == null ? void 0 : _a.data) == null ? void 0 : _b.addresses) || [];
      });
    };
    this.getAreas = async (params) => {
      var _a;
      const { data } = await this.locationApi.get("/location/areas", {
        params: __spreadValues({}, params)
      });
      return (_a = data.data) == null ? void 0 : _a.areas;
    };
    this.getAreasV2 = async (params, country) => {
      var _a;
      const { data } = await this.locationApi.get(`/location/areas${!!country ? `?country=${country}` : ""}`, {
        params: __spreadValues({}, params)
      });
      return (_a = data.data) == null ? void 0 : _a.areas;
    };
    this.getDistanceMatrix = async (origins, destinations) => {
      const { data } = await this.locationApi.post("/location/distance-matrix", {
        origins,
        destinations
      });
      return data;
    };
    this.locationApi = new Api(locationApiUrl, void 0, defaultConfig);
    this.country = countryCode;
    if (typeof getCustomAccessToken === "function") {
      this.locationApi.addInterceptor((request) => {
        request.headers.set("Authorization", `Bearer ${getCustomAccessToken()}`);
      });
    } else {
      this.locationApi.addInterceptor(accessTokenInterceptor);
    }
  }
}

export { LocationService };
